import {DataGroup} from 'vis-timeline/esnext';

const REGIONS: DataGroup[] = [
    {
        id: 'r1',
        content: 'Bayern',
        title: 'Diese Region und alle betroffenen Monteure aus-/einblenden',
        nestedGroups: [
            'mech11',
            'mech12'
        ],
        showNested: true
    },
    {
        id: 'r2',
        content: 'Saarland',
        title: 'Diese Region und alle betroffenen Monteure aus-/einblenden',
        nestedGroups: [
            'mech21',
            'mech22',
            'mech23'
        ],
        showNested: true
    }
];

export {REGIONS};
